import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

export default class BoardsPublicTemplatesRoute extends Route {
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};

		document.body.id = 'page-boards-public-templates';

		promises.initialRequests = this.navigationService.initialRequestsPromise;

		promises.templates = this.mmTemplatesService.requestBoardPublicTemplates();

		promises.boardLoopTemplates = this.mmTemplatesService.requestBoardLoopPublicTemplates();

		return hashSettled(promises);
	}
}
